<template>
    <div class="flex flex-center"  style="width: 100%">
        <input class="acclaro-search-input"
               id="large-search-input"
               @input="fireSearch"
               v-model="term"
               autocomplete="off"
               placeholder="Type keyword to search orders"
        />
        <hr/>
    </div>
</template>

<script>

/**
 * Responsible for providing and input form
 * and returning results from the Acclaro internal elastic
 * Order search API.
 *
 * Sample usage
 *        <AcclaroElasticSearchInput
 *           @handleResults="parseResults"
 *           :page="this.paginationDetails.current"
 *           :per-page="this.paginationDetails.offset"
 *           :range-start="this.timeAgo.value"
 *           :selected-account="this.selectedAccount"
 *           ref="searchHandler" # to fire callback via parent
 *         />
 *
 *  The results of the search will be passed back in a method handleResults
 */

import axios from "axios";
import {debounce} from "lodash";

export default {
    name: "AcclaroElasticSearchInput",
    data: function () {
        return {
            term: '',
        }
    },
    props: [
        'perPage',
        'page',
        'rangeStart',
        'selectedAccount'
    ],
    methods: {
        setSearchTerm(term){
            this.term = term;
        },
        fireSearch: debounce(function () {
            this.onSearchInput();
        }, 500),
        onSearchInput() {
            if (this.term.length < 3) {
                this.$emit('setNoResults');
                return;
            }
            EventBus.$emit('loader:show');

            const BASE_URL = window.location.origin;
            const url = new URL(BASE_URL + '/search/orders');

            url.searchParams.append("query_string", this.term);
            url.searchParams.append("size", this.perPage || 10);
            url.searchParams.append("from", this.page);
            url.searchParams.append("range_start", this.rangeStart);

            if(this.selectedAccount){
                url.searchParams.append("filters[account_id]",this.selectedAccount?.id || undefined);
            }

            return axios.get(url.href)
                .then(
                res => {
                    this.$emit('handleResults', res.data);
                    EventBus.$emit('loader:hide');
                }
            ).catch((e) => {
                console.error(e);
                EventBus.$emit('loader:hide');
            });
        }
    },
};
</script>

<style scoped>

#large-search-input {
    font-size: 17px;
    padding: 19px;
}

</style>
